export const makeReportValue = (value = 0) =>
  `$${Math.round(value).toLocaleString()}`
